import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BasicPage } from 'src/app/model/basic-page.model';
import { HttpService, interceptorsToken } from 'library-explorer';
import { catchError, take } from 'rxjs/operators';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BasicPageService {

  constructor(
    private httpService: HttpService,
    private authService: AuthService,
    private router: Router
  ) { }

  public getPageById(id: string): Observable<BasicPage> {
    const params = new HttpParams()
      .set('id', id)
      .set('active', 'true');

    return this.httpService.get<BasicPage>(`page`, params).pipe(
      catchError(this.handleError.bind(this))
    );
  }

  public getPageByAlias(alias: string): Observable<BasicPage> {
    const params = new HttpParams()
      .set('alias', alias)
      .set('active', 'true');

    return this.httpService.get<BasicPage>('page', params).pipe(
      catchError(this.handleError.bind(this))
    );
  }
  
  private handleError(err: HttpErrorResponse): any {
    switch (err.status) {
      case 403: {
        this.authService.isAuthorized().pipe(
          take(1)
        ).subscribe(isAuthorized => {
          if (isAuthorized) {
            this.router.navigate(['403']);
          } else {
            this.authService.redirectUrl = this.router.url;
            this.router.navigate(['/access', 'login']);
          }
        })
        break;
      }
    }
    throw err;
  }
}
